var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leaf-course" },
    [
      _vm._l(_vm.list, function(i) {
        return _c(
          "div",
          { key: i.id, staticClass: "class_block" },
          [
            _c("p", { staticClass: "tit" }, [_vm._v(_vm._s(i.title))]),
            _vm._v(" "),
            _vm._l(i.children, function(item) {
              return _c("div", { key: item.id, staticClass: "parent-list" }, [
                item.module_type == 1 ||
                (item.module_type == 19 && item.type == 3)
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item, _vm.coding)
                          }
                        }
                      },
                      [
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _c("span", [_vm._v("文档")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "placeline" }),
                            _vm._v(
                              " " + _vm._s(item.file_size) + "M\n            "
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.module_type == 19 && (item.type == 0 || item.type == 1)
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item, _vm.coding)
                          }
                        }
                      },
                      [
                        _vm._m(1, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _c("span", [_vm._v("作业")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "placeline" }),
                            _vm._v(
                              " " + _vm._s(item.file_size) + "M\n            "
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.module_type == 2 ||
                (item.module_type == 19 && item.type == 2)
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item, _vm.coding)
                          }
                        }
                      },
                      [
                        _vm._m(2, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _vm._v("\n              视频"),
                            item.video_time
                              ? _c("span", [
                                  _c("span", { staticClass: "placeline" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatSeconds")(item.video_time)
                                      )
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.module_type == 4 ||
                (item.module_type == 19 && item.type == 8)
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item)
                          }
                        }
                      },
                      [
                        _vm._m(3, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _vm._v("试卷")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.module_type == 5 ||
                (item.module_type == 19 && item.type == 4)
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item)
                          }
                        }
                      },
                      [
                        _vm._m(4, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _vm._v("练习")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.module_type == 6 && item.is_playback == 1
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item, _vm.coding)
                          }
                        }
                      },
                      [
                        _vm._m(5, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _vm._v("\n              回放  "),
                            (_vm.goodsType != 6 && _vm.goodsType != 10) ||
                            item.is_show_time
                              ? _c("span", [
                                  _c("span", { staticClass: "placeline" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("timeFormat")(item.start_time)
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("localDateH")(item.end_time)
                                      )
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : item.module_type == 6 ||
                    (item.module_type == 19 && item.type == 6)
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item, _vm.coding)
                          }
                        }
                      },
                      [
                        _vm._m(6, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _vm._v("\n              直播  "),
                            (_vm.goodsType != 6 && _vm.goodsType != 10) ||
                            item.is_show_time
                              ? _c("span", [
                                  _c("span", { staticClass: "placeline" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("timeFormat")(item.start_time)
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("localDateH")(item.end_time)
                                      )
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.module_type == 7 ||
                (item.module_type == 19 && item.type == 7)
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item, _vm.coding)
                          }
                        }
                      },
                      [
                        _vm._m(7, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _vm._v("讲义夹")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.module_type == 20 ||
                (item.module_type == 19 && item.type == 20)
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item, _vm.coding)
                          }
                        }
                      },
                      [
                        _vm._m(8, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _vm._v("模考")
                          ])
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.module_type == 9
                  ? _c(
                      "div",
                      {
                        staticClass: "com-child",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.judgetype(item)
                          }
                        }
                      },
                      [
                        _vm._m(9, true),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "other-msg" }, [
                            _vm._v("\n              直播  "),
                            (_vm.goodsType != 6 && _vm.goodsType != 10) ||
                            item.is_show_time
                              ? _c("span", [
                                  _c("span", { staticClass: "placeline" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("timeFormat")(item.start_time)
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("localDateH")(item.end_time)
                                      )
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            })
          ],
          2
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.handout_flag,
              expression: "handout_flag"
            }
          ],
          staticClass: "handout_assembly",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.parent.apply(null, arguments)
            }
          }
        },
        [
          _c("handoutFile", {
            staticClass: "handout_content",
            attrs: {
              files: _vm.handoutlist,
              cid: _vm.coding,
              packageid: _vm.package_id
            },
            on: { child: _vm.parent }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.applets_flag && _vm.ios
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { data: _vm.detail, type: 1 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.android
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 2 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.zujian_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + 'APP"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.scheme +
                              "?type=1&sso_id=" +
                              _vm.ssoid +
                              "&orderSn=" +
                              _vm.sn +
                              "&spuID=" +
                              _vm.shopid +
                              "&owner=" +
                              this.$route.query.owner +
                              "&channel=" +
                              this.$route.query.channel +
                              "&orgn=" +
                              this.$route.query.orgn
                          },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c(
                      "span",
                      { staticClass: "goapp", on: { click: _vm.search_flag } },
                      [_vm._v("去APP查看")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.zujians_flag
        ? _c("goapp", {
            attrs: { data: _vm.detail },
            on: { openapp: _vm.goapp }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "doc",
        attrs: { src: require("../../../static/images/doc.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "doc",
        attrs: { src: require("../../../static/images/doc.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "video",
        attrs: { src: require("../../../static/images/video.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "write",
        attrs: { src: require("../../../static/images/write.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "write",
        attrs: { src: require("../../../static/images/write.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "video",
        attrs: { src: require("../../../static/images/playback.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "write",
        attrs: { src: require("../../../static/images/zhibo.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "handout",
        attrs: { src: require("../../../static/images/handout.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "handout",
        attrs: { src: require("../../../static/images/dryRun.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "write",
        attrs: { src: require("../../../static/images/zhibo.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3af00471", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af00471","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leaf/index.vue
// module id = null
// module chunks = 